var map = {
	"./avaliacoes.svg": "590e",
	"./avaliacoesFill.svg": "036f",
	"./calendario.svg": "9c09",
	"./cardapio.svg": "9b3b",
	"./cardapioFill.svg": "6a56",
	"./compartilhar.svg": "7708",
	"./configuracao.svg": "20e0",
	"./configuracaoFill.svg": "a476",
	"./contrato.svg": "f048",
	"./cupomDesconto.svg": "1e69",
	"./cupomDescontoFill.svg": "8af3",
	"./cupomDescontoFillLight.svg": "7cb4",
	"./downloadFill.svg": "6825",
	"./financeiro.svg": "5e8b",
	"./financeiroFill.svg": "9cbd",
	"./formasPagamento.svg": "77f8",
	"./formasPagamentoFill.svg": "c9bb",
	"./horarioFuncionamento.svg": "7f86",
	"./horarioFuncionamentoFill.svg": "19be",
	"./icon-cupom-marketing.svg": "ebeb",
	"./icon-promo-marketing.svg": "f909",
	"./inicio.svg": "acb8",
	"./inicioFill.svg": "fbd3",
	"./marketing.svg": "14d6",
	"./marketingFill.svg": "b307",
	"./notificacao.svg": "a8a0",
	"./notificacaoFill.svg": "c08e",
	"./pedidos.svg": "dd55",
	"./pedidosFill.svg": "ece5",
	"./perguntasFrequentes.svg": "72df",
	"./perguntasFrequentesFill.svg": "0b84",
	"./relatorio.svg": "3553",
	"./relatorioFill.svg": "d536",
	"./taxaEntrega.svg": "52b5",
	"./taxaEntregaFill.svg": "8e79",
	"./termosAdesao.svg": "ef2a",
	"./termosAdesaoFill.svg": "d7bb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0075";